import alt from '../alt';
import CreateAccountActions from './CreateAccountActions';

class CreateAccountStore {
	constructor() {

		this.state = {
			accountModel: {
				FirstName: '',
				LastName: '',
				Email: '',
				Password: '',
				PasswordConfirm: '',
				canSubmitAccount: false,
				Address: null,
				Phone: ''
			},
			accountHasError: false,
			accountCreated: false
		}

		this.bindListeners({
			enrollSuccess: CreateAccountActions.ENROLL_SUCCESS,
			enrollFailure: CreateAccountActions.ENROLL_FAILURE,
		});
	}

	enrollSuccess(data) {
		this.setState({
			accountCreated: true
		})
	}

	enrollFailure(response) {
		this.setState({
			accountHasError: true
		})
	}
}

export default alt.createStore(CreateAccountStore, 'CreateAccountStore');



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/GuestCheckout/CreateAccountStore.js